/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { getAllArticulos } from '../../../Services/articuloService'

const useModalArticulo = (modalId = 'modalArticuloStock') => {
    const isMountedRef = useRef(true)
    const [articulos, setArticulos] = useState([])
    const [isLoad, setIsLoad] = useState(true)
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [query, setQuery] = useState('')
    const [searchCriteria, setSearchCriteria] = useState('nombre')
    const [isOpen, setIsOpen] = useState(false)
    const lastSearchRef = useRef('')

    // Función para validar el input según el criterio seleccionado
    const validateInput = (value, criteria) => {
        switch (criteria) {
            case 'nombre':
                // Solo letras
                return /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s\-.]*$/.test(value)
            case 'codigo':
                // Solo números
                return /^\d*$/.test(value)
            case 'codigoBarra':
                // Sin restricción (números y letras)
                return true
            default:
                return true
        }
    }

    // Función para mostrar mensaje de advertencia según el criterio
    const showValidationWarning = (criteria) => {
        let title = ''

        switch (criteria) {
            case 'nombre':
                title = 'Solo se permiten letras'
                break
            case 'codigo':
                title = 'Solo se permiten números'
                break
            default:
                return
        }

        Swal.fire({
            title: title,
            type: 'warning',
            showConfirmButton: false,
            timer: 2000,
            toast: true,
            position: 'top'
        })
    }

    // Funciones para abrir y cerrar modal
    const handleOpenModal = () => {
        // Reseteo la busqueda cuando abro el modal:
        lastSearchRef.current = ''
        setIsOpen(true)
    }

    const handleCloseModal = () => {
        setIsOpen(false)
    }

    const handleAnimationEnd = () => {
        // Si el modal se cierra, se actualiza isOpen
        if (
            !document.getElementById(modalId)?.classList.contains('show')
        ) {
            setIsOpen(false)
        }
    }

    // Función para obtener parámetros según criterio seleccionado
    const getSearchParams = (searchTerm, criteria) => {
        const cleanTerm = searchTerm.trim()

        return {
            codigo: criteria === 'codigo' ? cleanTerm : '',
            nombre: criteria === 'nombre' ? cleanTerm : '',
            codigoBarra: criteria === 'codigoBarra' ? cleanTerm : ''
        }
    }

    const fetchArticles = async (searchTerm = '') => {
        setIsLoad(true)
        const { codigo, nombre, codigoBarra } = getSearchParams(searchTerm, searchCriteria)

        getAllArticulos(true, 0, nombre, 50, codigo, codigoBarra)
            .then((res) => {
                if (isMountedRef.current) {
                    setArticulos(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setPage(0)
                    setIsLoad(false)
                }
            })
            .catch((error) => {
                if (isMountedRef.current) {
                    console.log(error.response)
                }
            })
    }

    useEffect(() => {
        if (isOpen) {
            fetchArticles()
        }
    }, [isOpen])

    useEffect(() => {
        return () => {
            isMountedRef.current = false
        }
    }, [])


    const onChangeArticulo = (e) => {
        const inputValue = e.target.value

        // Validar el input según el criterio seleccionado
        if (!validateInput(inputValue, searchCriteria)) {
            // Mostrar advertencia específica según el criterio
            showValidationWarning(searchCriteria)
            // Si no pasa la validación, no actualizar el estado
            return
        }

        setQuery(inputValue)
    }

    const handleSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            const trimmedValue = query.trim()
            if (trimmedValue === '' && lastSearchRef.current !== '') {
                const { codigo, nombre, codigoBarra } = getSearchParams('', searchCriteria)

                getAllArticulos(true, 0, nombre, 50, codigo, codigoBarra)
                    .then((res) => {
                        if (isMountedRef.current) {
                            setPage(0)
                            setArticulos(res.data.content)
                            setTotalRegister(res.data.totalElements)
                            setTotalPage(res.data.totalPages)
                            setIsLoad(false)
                            lastSearchRef.current = ''
                        }
                    })
                    .catch((error) => {
                        if (isMountedRef.current) {
                            console.log(error.response)
                        }
                    })
            }
            // Si hay contenido y es diferente a la última búsqueda, hace una nueva búsqueda
            else if (trimmedValue !== '' && trimmedValue !== lastSearchRef.current) {
                const { codigo, nombre, codigoBarra } = getSearchParams(trimmedValue, searchCriteria)

                getAllArticulos(true, 0, nombre, 50, codigo, codigoBarra)
                    .then((res) => {
                        if (isMountedRef.current) {
                            setPage(0)
                            setArticulos(res.data.content)
                            setTotalRegister(res.data.totalElements)
                            setTotalPage(res.data.totalPages)
                            setIsLoad(false)
                            lastSearchRef.current = trimmedValue
                        }
                    })
                    .catch((error) => {
                        if (isMountedRef.current) {
                            console.log(error.response)
                        }
                    })
            }
        }
    }

    const onChangeSearchCriteria = (e) => {
        setSearchCriteria(e.target.value)
        setQuery('')
        fetchArticles()
    }

    const nextPage = () => {
        if (totalPage === 0 || page >= totalPage - 1) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }

        const { codigo, nombre, codigoBarra } = getSearchParams(query, searchCriteria)

        getAllArticulos(true, page + 1, nombre, 50, codigo, codigoBarra)
            .then((res) => {
                if (isMountedRef.current) {
                    setPage(page + 1)
                    setTotalPage(res.data.totalPages)
                    setTotalRegister(res.data.totalElements)
                    setArticulos(res.data.content)
                    setIsLoad(false)
                }
            })
            .catch((error) => {
                if (isMountedRef.current) {
                    console.log(error)
                }
            })
    }

    const previousPage = () => {
        if (page === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        const { codigo, nombre, codigoBarra } = getSearchParams(query, searchCriteria)

        getAllArticulos(true, page - 1, nombre, 50, codigo, codigoBarra)
            .then((res) => {
                if (isMountedRef.current) {
                    setPage(page - 1)
                    setTotalPage(res.data.totalPages)
                    setTotalRegister(res.data.totalElements)
                    setArticulos(res.data.content)
                    setIsLoad(false)
                }
            })
            .catch((error) => {
                if (isMountedRef.current) {
                    console.log(error)
                }
            })
    }

    return {
        articulos,
        totalRegister,
        totalPage,
        page,
        nextPage,
        previousPage,
        onChangeArticulo,
        handleSearchKeyPress,
        onChangeSearchCriteria,
        searchCriteria,
        query,
        isLoad,
        handleOpenModal,
        handleCloseModal,
        handleAnimationEnd
    }
}

export default useModalArticulo
